import {
  IFillDataWizardBuy,
  TKeyOfDataWizardBuy,
  TNumberKeysOfIFillDataWizardBuy,
} from "../..";
import SelectionByOwnAppStep_1 from "../selectionByOwnAppSteps/step_1";
import SelectionByOwnAppStep_2 from "../selectionByOwnAppSteps/step_2";
import SelectionByOwnAppStep_3 from "../selectionByOwnAppSteps/step_3";

const getSelectionByOwnAppSteps = (
  data: IFillDataWizardBuy,
  dataFormEstimate: Partial<IFillDataWizardBuy>,
  handleChangeDataObject: (data: Partial<IFillDataWizardBuy>) => void,
  handleChangeDataNumber: (
    data: number | number[],
    key: TNumberKeysOfIFillDataWizardBuy
  ) => void,
  onReset: (key: TKeyOfDataWizardBuy[]) => void,
  disabledAndPrev: {
    isNextStep_estimateWithoutApartment: boolean;
    isNextStepDisabled_selectedFacilityTypeOwnFacility: boolean;
  }
) => {
  const {
    isNextStep_estimateWithoutApartment,
    isNextStepDisabled_selectedFacilityTypeOwnFacility,
  } = disabledAndPrev;

  return [
    <SelectionByOwnAppStep_1
      onChangePrice={handleChangeDataNumber}
      onChange={handleChangeDataObject}
      isNextStepDisabled={isNextStep_estimateWithoutApartment}
      onReset={onReset}
      dataFormEstimate={dataFormEstimate}
    />,
    <SelectionByOwnAppStep_2
      isNextStepDisabled={isNextStepDisabled_selectedFacilityTypeOwnFacility}
      onChange={handleChangeDataNumber}
      data={data.selectedFacilityTypeOwnFacility}
      onReset={onReset}
    />,
    <SelectionByOwnAppStep_3 />,
  ];
};

export default getSelectionByOwnAppSteps;
